var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";

import { EmbededButton } from "../../../../Components/UI/EmbededButton";






import { Dot } from "./Dot";
import { SuggestedValue } from "./SuggestedValue";
import { propertyIcons } from "./Icons";

const extractorColumnHelper = createColumnHelper();
const suggestionColumnHelper = createColumnHelper();

const statusColor = (suggestion) => {
  if (!suggestion.isChild && (!suggestion.suggestedValue || suggestion.suggestedValue === '')) {
    return 'red';
  }

  if (suggestion.currentValue === suggestion.suggestedValue) {
    return 'green';
  }

  if (
  Array.isArray(suggestion.currentValue) &&
  Array.isArray(suggestion.suggestedValue) &&
  suggestion.currentValue.length === suggestion.suggestedValue.length &&
  suggestion.currentValue.every(
    (value) => Array.isArray(suggestion.suggestedValue) && suggestion.suggestedValue.includes(value)
  ))
  {
    return 'green';
  }

  return 'orange';
};

const getIcon = (color) => {
  switch (color) {
    case 'orange':
    case 'green':
      return /*#__PURE__*/_jsx(CheckCircleIcon, {});
    case 'red':
      return /*#__PURE__*/_jsx(Dot, { color: color });
    default:
      return '';
  }
};

const ExtractorHeader = () => /*#__PURE__*/_jsx(Translate, { className: "whitespace-nowrap" }, void 0, "Extractor Name");
const PropertyHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Property");
const TemplatesHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Template(s)");
const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Document FOR");
const CurrentValueHeader = () => /*#__PURE__*/
_jsx(Translate, { className: "whitespace-nowrap" }, void 0, "Current Value/Suggestion");

const AcceptHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Accept");
const SegmentHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Context");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Action");

const PropertyCell = ({ cell }) => {
  const property = cell.getValue();
  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "w-5" }, void 0, propertyIcons[property]), /*#__PURE__*/
    _jsx("p", { className: "text-gray-500 whitespace-nowrap" }, void 0, cell.row.original.propertyLabel)
    ));

};

const RenderParent = ({ suggestion }) => {
  const suggestions = suggestion.subRows;
  const ammountOfSuggestions = suggestions.length;
  const amountOfValues = suggestions.filter((s) => s.currentValue).length;
  const amountOfMatches = suggestions.filter((s) => s.currentValue === s.suggestedValue).length;
  const amountOfMissmatches = ammountOfSuggestions - amountOfMatches;

  return (/*#__PURE__*/
    _jsx("div", { className: "flex gap-1 text-xs font-bold text-gray-500" }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0,
    amountOfValues, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "values")
    ), /*#__PURE__*/
    _jsx("span", {}, void 0, "|"), /*#__PURE__*/
    _jsx("span", {}, void 0,
    ammountOfSuggestions, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "suggestions")
    ),
    amountOfMatches > 0 && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("span", {}, void 0, "|"), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-green-500" }, void 0, amountOfMatches), ' ', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "matching")
    )
    ),

    amountOfMissmatches > 0 && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("span", {}, void 0, "|"), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-orange-500" }, void 0, amountOfMissmatches), ' ', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "mismatching")
    )
    )

    ));

};

const CurrentValueCell = ({
  cell,
  allProperties






}) => {
  if (cell.row.original.state.obsolete) {
    return (/*#__PURE__*/
      _jsx("div", { className: "flex gap-1 text-xs font-bold text-gray-500" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Obsolete")
      )
      ));

  }

  if (cell.row.original.state.error) {
    return (/*#__PURE__*/
      _jsx("div", { className: "flex gap-1 text-xs font-bold text-gray-500" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { className: "text-error-500" }, void 0, "Error")
      )
      ));

  }

  if ('subRows' in cell.row.original) {
    return /*#__PURE__*/_jsx(RenderParent, { suggestion: cell.row.original });
  }
  return (/*#__PURE__*/
    _jsx(SuggestedValue, {
      value: cell.getValue(),
      suggestion: cell.row.original,
      templateProperties: allProperties }
    ));

};

const AcceptButton = ({
  cell,
  action



}) => {
  const color = statusColor(cell.row.original);
  const suggestionHasEntity = Boolean(cell.row.original.entityId);

  if (color === 'green') {
    return /*#__PURE__*/_jsx("div", { className: "w-6 h-6 m-auto" }, void 0, getIcon(color));
  }

  return (/*#__PURE__*/
    _jsx("div", { className: "m-auto" }, void 0, /*#__PURE__*/
    _jsx(EmbededButton, {
      icon: getIcon(color),
      color: color,
      disabled: color === 'red' || !suggestionHasEntity,
      onClick: () => action && action([cell.row.original]) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Accept")
    )
    ));

};

const TemplatesCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((templateName) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, templateName, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, templateName)
)
)
);


const LinkButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `suggestions/${cell.getValue()}` }, void 0, /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Review")
)
);


const OpenPDFButton = ({
  cell,
  action



}) => {
  const suggestionHasEntity = Boolean(cell.row.original.entityId);

  return (/*#__PURE__*/
    _jsx(Button, {
      className: "leading-4",
      styling: "light",
      disabled: !suggestionHasEntity,
      onClick: () => action && action(cell.row.original) }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "whitespace-nowrap" }, void 0, "Open PDF")
    ));

};

const TitleCell = ({ cell, row }) => /*#__PURE__*/
_jsx("div", { className: "text-sm font-normal text-primary-700" }, void 0, /*#__PURE__*/
_jsx("a", { href: `/entity/${row.original.sharedId}`, target: "_blank", rel: "noreferrer" }, void 0,
cell.getValue(), " (", row.original.language, ")"
)
);


const SegmentCell = ({ cell, row }) => {
  const segment = cell.getValue();
  if (row.getCanExpand()) {
    return null;
  }
  if (segment === '') {
    return (/*#__PURE__*/
      _jsx("span", { className: "text-xs font-normal text-orange-600" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "No context")
      ));

  }
  return segment;
};

const extractorsTableColumns = [
extractorColumnHelper.accessor('name', {
  header: ExtractorHeader,
  meta: { headerClassName: 'w-1/6' }
}),
extractorColumnHelper.accessor('propertyType', {
  header: PropertyHeader,
  cell: PropertyCell,
  meta: { headerClassName: 'w-1/6' }
}),
extractorColumnHelper.accessor('namedTemplates', {
  header: TemplatesHeader,
  enableSorting: false,
  cell: TemplatesCell,
  meta: { headerClassName: 'w-4/6' }
}),
extractorColumnHelper.accessor('_id', {
  header: ActionHeader,
  enableSorting: false,
  cell: LinkButton,
  meta: { headerClassName: 'sr-only' }
})];




const suggestionsTableColumnsBuilder = (
templates,
acceptSuggestions,
openPdfSidepanel) =>
{
  const allProperties = [...(templates[0].commonProperties || []), ...templates[0].properties];

  return [
  suggestionColumnHelper.accessor('entityTitle', {
    header: TitleHeader,
    cell: TitleCell,
    meta: { headerClassName: 'w-1/4' }
  }),
  suggestionColumnHelper.accessor('segment', {
    header: SegmentHeader,
    cell: SegmentCell,
    meta: { headerClassName: 'w-1/4' }
  }),
  suggestionColumnHelper.accessor('currentValue', {
    header: CurrentValueHeader,
    cell: (cell) => /*#__PURE__*/_jsx(CurrentValueCell, { cell: cell, allProperties: allProperties }),
    meta: { headerClassName: 'w-1/4' }
  }),
  suggestionColumnHelper.display({
    id: 'accept-actions',
    header: AcceptHeader,
    cell: ({ cell, row }) => {
      if (row.depth === 0) {
        return /*#__PURE__*/_jsx(AcceptButton, { action: acceptSuggestions, cell: cell });
      }
      return null;
    },
    meta: {
      headerClassName: 'w-2/12',
      contentClassName: 'text-center'
    }
  }),
  suggestionColumnHelper.display({
    id: 'open-pdf-actions',
    header: ActionHeader,
    cell: ({ cell, row }) =>
    row.depth === 0 ? /*#__PURE__*/
    _jsx(OpenPDFButton, { action: openPdfSidepanel, cell: cell }) : /*#__PURE__*/

    _jsx(AcceptButton, { action: acceptSuggestions, cell: cell }),

    meta: {
      headerClassName: 'w-2/12',
      contentClassName: 'text-center'
    }
  })];

};

export { extractorsTableColumns, suggestionsTableColumnsBuilder };